import React from 'react';
import Overview from '../components/Overview';

export default ({
  toc,
  data,
  sequences,
}) => {

  return (
    <>
      <main className="content-container">
        <h2>Protocole et objectifs</h2>
        <p>
        Les documents ici présentés sont principalement le fruit d’entretiens semi-directifs exploratoires d’un peu plus d’une heure avec divers membres de l’équipe de développement du projet AIME, et particulièrement de sa part numérique. Ils ont été réalisés dans une situation de découverte du projet AIME et de l’oeuvre de l’auteur principal, dans les premiers mois du terrain.
        </p>
        <p>
        Après leur transcription, ces éléments ont été découpés en diverses parties sélectionnées selon des critères de pertinence et de confidentialité. Plutôt que d’être montées sur un registre narratif entièrement linéaire et éditorial (comme le serait la réalisation d’un documentaire de recherche), elles sont livrées à l’état de “semi-finis”, morceaux choisis d’une enquête dont la conclusion est encore à faire. Elles ont été annotées de manière à permettre une recherche aisée, et configurées sous la forme “de témoignages” et d’axes destinées à éclairer divers aspects et retours d’expérience de ce projet.
        </p>
        <p>
        L’objectif de cette réalisation est d’ouvrir le matériau d’une recherche en cours sous un angle critique, permettant des pratiques d’interprétation chez les lecteurs et mettant en oeuvre différentes expérimentations en termes de navigation et de manipulation de ce matériau. Il s’agit d’une forme d’ouverture des données de la recherche (open data) reconfigurée et mise en forme à travers des pratiques de design.
        </p>
        <p>
        Au-delà d’un positionnement performatif vis-à-vis de la thèse dans le cadre de laquelle ce site est produit (une publication sur les formes de publication), il s’agit d’expérimenter comment l’élaboration d’instruments de recherche spécifiques à ses questionnements seront à même, par la suite, de produire des résultats inattendus.
        </p>
        <p>
        Interviews en français et en anglais
        </p>
      </main>
      <aside>
        <div className="content-container">
          <Overview
            data={data}
            sequences={sequences}
          />
        </div>
      </aside>
    </>
  )
}